'use strict';

/*
---
description: FED Process
authors:
- David Chan CK
license:
- MIT-style license
requires:
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
provides: [LazyLoader]
...
*/
Page.Lkp = new Class({
	Extends: Page,
	build: function build() {
		this.parent();

		this.initScrollAnimations();
		this.initParallaxEffects();
		this.initNumberCounters();
		this.addFloatingShapes();
		this.initMagneticButtons();
	},

	// Scroll-triggered animations using Intersection Observer with staggered children
	initScrollAnimations: function initScrollAnimations() {
		var observerOptions = {
			threshold: 0.1,
			rootMargin: '0px 0px -100px 0px'
		};

		// Helper to trigger animations
		function triggerAnimations(target) {
			target.classList.add('observed');
			var children = target.querySelectorAll('.animate-on-scroll');
			children.forEach(function (child) {
				child.classList.add('animate-in');
			});
		}

		var observer = new IntersectionObserver(function (entries) {
			entries.forEach(function (entry) {
				if (entry.isIntersecting && !entry.target.classList.contains('observed')) {
					triggerAnimations(entry.target);
				}
			});
		}, observerOptions);

		// Helper function to add staggered animations to children
		function addStaggeredAnimations(container, selector, animationClass) {
			var elements = container.querySelectorAll(selector);
			var delayIndex = 0;
			var animClass = animationClass || 'fade-up';

			elements.forEach(function (element) {
				element.classList.add('animate-on-scroll', animClass);
				if (delayIndex > 0) {
					element.classList.add('stagger-delay-' + delayIndex);
				}
				delayIndex++;
			});
		}

		// Animate hero section - always on page load
		var heroLeft = document.querySelector('.hero-left');
		if (heroLeft) {
			var heroElements = heroLeft.querySelectorAll('h1, p');
			heroElements.forEach(function (element, index) {
				element.classList.add('animate-on-scroll', 'fade-up');
				if (index > 0) {
					element.classList.add('stagger-delay-' + index);
				}
				// Trigger immediately on page load
				setTimeout(function () {
					element.classList.add('animate-in');
				}, 50);
			});
		}

		var heroRight = document.querySelector('.hero-right');
		if (heroRight) {
			var infoBox = heroRight.querySelector('.info-box');
			if (infoBox) {
				infoBox.classList.add('animate-on-scroll', 'fade-up', 'stagger-delay-1');
				// Always trigger on page load
				setTimeout(function () {
					infoBox.classList.add('animate-in');
				}, 50);
			}
		}

		// Animate all content sections with staggered children
		var sections = document.querySelectorAll('.lkp-section-container');
		sections.forEach(function (section) {
			// Animate section title
			var title = section.querySelector('.primary-title');
			if (title) {
				title.classList.add('animate-on-scroll', 'fade-up');
			}

			// Animate left content with staggered children (exclude buttons for magnetic effect)
			var leftContent = section.querySelector('.lkp-content-left');
			if (leftContent) {
				addStaggeredAnimations(leftContent, '.secondary-title, p, .lkp-highlight, a:not(.button-primary):not(.button-secondary)');

				// Animate buttons with full fade-up, then clear animation to allow magnetic effect
				var buttons = leftContent.querySelectorAll('.button-primary, .button-secondary');
				buttons.forEach(function (button) {
					button.classList.add('animate-on-scroll', 'fade-up', 'stagger-delay-3');
					button.addEventListener('animationend', function () {
						// Set final state before clearing animation
						button.style.opacity = '1';
						button.style.transform = '';
						button.style.animation = 'none';
					}, { once: true });
				});
			}

			// Animate right content (images)
			var rightContent = section.querySelector('.lkp-content-right');
			if (rightContent) {
				rightContent.classList.add('animate-on-scroll', 'fade-right', 'stagger-delay-2');
			}

			// Observe the section
			observer.observe(section);
		});

		// Animate new development section with staggered columns
		var newdevSection = document.querySelector('.lkp-newdev');
		if (newdevSection) {
			var newdevTitle = newdevSection.querySelector('.primary-title');
			if (newdevTitle) {
				newdevTitle.classList.add('animate-on-scroll', 'fade-up');
			}

			var newdevColumns = newdevSection.querySelectorAll('.newdev-column');
			newdevColumns.forEach(function (column, index) {
				addStaggeredAnimations(column, '.secondary-title, p, a:not(.button-primary):not(.button-secondary)');
				column.classList.add('stagger-delay-' + (index + 1));

				// Animate buttons with full fade-up, then clear animation to allow magnetic effect
				var buttons = column.querySelectorAll('.button-primary, .button-secondary');
				buttons.forEach(function (button) {
					button.classList.add('animate-on-scroll', 'fade-up', 'stagger-delay-3');
					button.addEventListener('animationend', function () {
						// Set final state before clearing animation
						button.style.opacity = '1';
						button.style.transform = '';
						button.style.animation = 'none';
					}, { once: true });
				});
			});

			observer.observe(newdevSection);
		}
	},

	// Parallax mouse movement effects
	initParallaxEffects: function initParallaxEffects() {
		var contentWrappers = document.querySelectorAll('.lkp-content-wrapper');

		contentWrappers.forEach(function (wrapper) {
			var rightContent = wrapper.querySelector('.lkp-content-right');
			if (!rightContent) return;

			wrapper.addEventListener('mousemove', function (e) {
				var rect = wrapper.getBoundingClientRect();
				var x = (e.clientX - rect.left) / rect.width;
				var y = (e.clientY - rect.top) / rect.height;

				var moveX = (x - 0.5) * 20;
				var moveY = (y - 0.5) * 20;

				rightContent.style.transform = 'translate(' + moveX + 'px, ' + moveY + 'px) scale(1.05)';
			});

			wrapper.addEventListener('mouseleave', function () {
				rightContent.style.transform = '';
			});
		});
	},

	// Animated number counters for pricing
	initNumberCounters: function initNumberCounters() {
		var highlights = document.querySelectorAll('.lkp-highlight strong');

		var observer = new IntersectionObserver(function (entries) {
			entries.forEach(function (entry) {
				if (entry.isIntersecting && !entry.target.classList.contains('counted')) {
					entry.target.classList.add('counted');
					animateNumber(entry.target);
				}
			});
		}, { threshold: 0.5 });

		function animateNumber(element) {
			var text = element.textContent;
			var match = text.match(/\$(\d+)/);
			if (!match) return;

			var targetNumber = parseInt(match[1]);
			var current = 0;
			var increment = targetNumber / 30;
			var duration = 1000;
			var stepTime = duration / 30;

			var timer = setInterval(function () {
				current += increment;
				if (current >= targetNumber) {
					current = targetNumber;
					clearInterval(timer);
				}
				element.textContent = text.replace(/\$\d+/, '$' + Math.floor(current));
			}, stepTime);
		}

		highlights.forEach(function (highlight) {
			observer.observe(highlight);
		});
	},

	// Add floating shapes dynamically to page background
	addFloatingShapes: function addFloatingShapes() {
		// Shapes disabled
		return;
	},

	// Magnetic button effect (subtle)
	initMagneticButtons: function initMagneticButtons() {
		var buttons = document.querySelectorAll('.button-primary, .button-secondary');

		buttons.forEach(function (button) {
			button.addEventListener('mousemove', function (e) {
				var rect = button.getBoundingClientRect();
				var x = e.clientX - rect.left - rect.width / 2;
				var y = e.clientY - rect.top - rect.height / 2;

				var moveX = x * 0.15;
				var moveY = y * 0.15;

				// Combine magnetic effect with hover lift (-2px)
				button.style.transform = 'translate3d(' + moveX + 'px, ' + (moveY - 2) + 'px, 0)';
			});

			button.addEventListener('mouseleave', function () {
				button.style.transform = '';
			});
		});
	}
});
//# sourceMappingURL=lkp.js.map
